import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '@app/services/auth.service';
import { CommonService } from '@app/services/common.service';
import { environment } from 'src/environments/environment';
import { UserClinicListResponse } from './select-user-clinic-dialog.model';

@Injectable({
  providedIn: 'root',
})
export class SelectUserClinicDialogService {
  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private authService: AuthenticationService
  ) {}

  getUserClinics(userId: string, hasPharmacy?: boolean) {
    let url = `${environment.baseAPIUrl}/users/${userId}/centres`;

    const shouldFilterByPharmacy =
      hasPharmacy &&
      !this.authService.isAdmin() &&
      !this.authService.isOpsManager();

    if (shouldFilterByPharmacy) {
      url += '?hasPharmacy=true';
    }

    return this.http.get<UserClinicListResponse>(url, {
      headers: this.commonService.getRequestHeaders(),
    });
  }
}
